var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"input",attrs:{"placeholder":_vm.placeholder,"name":_vm.name,"disabled":_vm.masked},domProps:{"value":_vm.shownValue},on:{"focus":_vm.focus,"blur":_vm.blur,"input":function($event){return _vm.updateValue()},"change":_vm.change}})])
}
var staticRenderFns = []

export { render, staticRenderFns }